import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import lzSCommonsFormErrorsAtom from '@lz-atoms/Commons/formErrors';
import useLzFApiCall from '@lz/services/Api';
import { lzFShowSuccessMessage } from '@lz/services/Utils';
import { LzTFormSizes, LzTOpenObject } from '@lz/typings/types';
import LzSApp from '@lz/app/App';
import LzXForm from '../../../forms/Form';
import LzXInputField from '../../../forms/fields/InputField';
import { useAtomValue } from 'jotai';

export interface LzPPageChangePassword {
  className?: string;
  style?: React.CSSProperties;
  formSize?: LzTFormSizes;
  children?: React.ReactNode;
}

const LzXPageChangePassword = (props: LzPPageChangePassword) => {
  const [passwordData, setPasswordData] = useState<LzTOpenObject>({ oldWp: '', newWp: '', cfmWp: '' });
  const [formErrorsStateForCfmPwd, setFormErrorsStateForCfmPwd] = useState<LzTOpenObject>({});

  const lzApiCall = useLzFApiCall();

  const formErrorsState = useAtomValue(lzSCommonsFormErrorsAtom);

  const handleFormSubmit: React.FormEventHandler<HTMLFormElement> = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = await lzApiCall('password', passwordData, 'post');
    if (data) {
      lzFShowSuccessMessage('Your password is changed successfully!');
      return true;
    }
    return false;
  };

  const handleInputChange = (key: string, value: any) => {
    const updated = Object.assign({}, passwordData);
    updated[key] = value;
    if (updated.newWp !== updated.cfmWp) {
      setFormErrorsStateForCfmPwd({ cfmWp: 'New and confirm password must match!' });
    } else {
      setFormErrorsStateForCfmPwd({});
    }
    setPasswordData(updated);
  };

  return (
    <LzSApp.WrapperTemplate private screenTitle='Change Password'>
      {props.children
        ?
        props.children
        :
        <div className={'lz-form-page lz-form-page-full lz-form-page-no-top-margin'}>
          <LzXForm noCancel submitLabel='Change Password' onSubmit={handleFormSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ sm: 6, md: 4 }}>
                <LzXInputField fluid required type='password' label='Old Password' placeholder='enter your old password'
                  name='oldWp' value={passwordData.oldWp} onChange={handleInputChange} formErrors={formErrorsState} />
              </Grid>

              <Grid size={{ sm: 6, md: 4 }}>
                <LzXInputField fluid required type='password' label='New Password' placeholder='enter your new password'
                  name='newWp' value={passwordData.newWp} onChange={handleInputChange} formErrors={formErrorsState} />
              </Grid>

              <Grid size={{ sm: 6, md: 4 }}>
                <LzXInputField fluid required type='password' label='Confirm Password' placeholder='enter your confirm password'
                  name='cfmWp' value={passwordData.cfmWp} onChange={handleInputChange} formErrors={formErrorsStateForCfmPwd} />
              </Grid>
            </Grid>
          </LzXForm>
        </div>
      }
    </LzSApp.WrapperTemplate>
  );
};

export default LzXPageChangePassword;
